import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { AuditLog } from '../../../domain/rbac/RbacDomains';
import LanguageUtil from '../../../util/LanguageUtil';
import getExportImportComponentLabel from './ExportImportComponentLabel';

const formatPath = (path: string | undefined): string | undefined => {
  if (path == undefined) {
    return undefined;
  }
  const hasExtension = /\.[a-zA-Z0-9]+$/.test(path);
  return hasExtension ? path.split('/').pop() : undefined;
};

class ExportImportAuditDetailComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { audit } = this.props;
    const data: Record<string, any> = (audit.document.data as unknown as Record<string, any>) ?? {};
    const filterDescription: string[] = Array.isArray(data.filterDescription) ? data.filterDescription : [];
    const componentName = data.chartId ?? data.list ?? data.transaction ?? data.logId;

    const items: Array<{ label: string; value: any }> = [
      { label: LanguageUtil.get({ id: 'common.label.component', defaultMessage: 'Component' }), value: getExportImportComponentLabel(audit.component) },
      {
        label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.componentName', defaultMessage: 'Component Name' }),
        value: componentName,
      },
    ];

    if (data.transaction != undefined) {
      items.push({ label: LanguageUtil.get({ id: 'common.label.channel', defaultMessage: 'Channel' }), value: data.transaction });
    }
    if (data.configurationName != undefined) {
      items.push({
        label: LanguageUtil.get({ id: 'common.label.configuration', defaultMessage: 'Configuration' }),
        value: data.configurationName,
      });
    }
    const groups: { label: string }[] = Array.isArray(data.groups) ? data.groups : [];
    if (groups.length > 0) {
      items.push({
        label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.fields', defaultMessage: 'Fields' }),
        value: groups.map((group) => group.label).join(', '),
      });
    }

    items.push(
      {
        label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.recordCount', defaultMessage: 'Record Count' }),
        value: data.recordCount,
      },
      { label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.format', defaultMessage: 'Format' }), value: data.format ?? data.extension },
      { label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.path', defaultMessage: 'Path' }), value: formatPath(data.path) },
      { label: LanguageUtil.get({ id: 'common.label.ip', defaultMessage: 'IP' }), value: audit.ip },
      {
        label: LanguageUtil.get({ id: 'pages.admin.audit.exportImport.failureReason', defaultMessage: 'Failure Reason' }),
        value: audit.reason,
      },
    );

    return (
      <>
        <button
          className={'text-[#458EF7] hover:underline text-xs'}
          onClick={() => this.setState({ isOpen: true })}
          data-testid='export_import_audit_detail_button'
        >
          {LanguageUtil.get({ id: 'components.audit.table.showDetail', defaultMessage: 'Show detail' })}
        </button>

        <Dialog
          header={LanguageUtil.get({ id: 'components.audit.table.detail', defaultMessage: 'Detail' })}
          headerClassName={'text-primary font-semibold text-md'}
          className={'w-[450px] text-sm'}
          visible={this.state.isOpen}
          onHide={() => this.setState({ isOpen: false })}
          dismissableMask
        >
          <div className={'flex flex-col gap-y-2'}>
            {items.map(({ label, value }) => (
              <div key={label} className={'flex gap-x-2'}>
                <span className={'font-semibold'}>{label}:</span>
                <span className={'break-all'}>{value == undefined || value === '' ? 'N/A' : String(value)}</span>
              </div>
            ))}
            {filterDescription.length > 0 && (
              <div className={'flex flex-col gap-y-1'}>
                <span className={'font-semibold'}>
                  {LanguageUtil.get({ id: 'pages.admin.audit.exportImport.filters', defaultMessage: 'Filters' })}:
                </span>
                <div className={'flex flex-col gap-y-0.5 pl-3'}>
                  {filterDescription.map((line, index) => (
                    <span key={index} className={'break-all'}>
                      {index + 1}. {line}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Dialog>
      </>
    );
  }
}

interface Props {
  audit: AuditLog;
}

class State {
  isOpen: boolean = false;
}

export default ExportImportAuditDetailComponent;
